angular.module('record-list.pagination', []);